import React, { useEffect } from "react";
import Routes from "./Routes";
import { BrowserRouter, useLocation } from "react-router-dom";
import SystemStatusGuard from "./components/SystemStatusGuard";
import AnnouncementSystem from "./components/AnnouncementSystem";
import { Toaster } from 'sonner';
import { CookieConsentBanner } from "./components/CookieConsentBanner";
import OfflineIndicator from "./components/ui/OfflineIndicator";
import DiscountBanner from "./components/DiscountBanner";

import { AuthProvider } from "./contexts/AuthContext";
import { AuthModalProvider } from "./contexts/AuthModalContext";
import { FeatureFlagsProvider } from "./contexts/FeatureFlagsContext";

function App() {
  useEffect(() => {
    const saved = localStorage.getItem('theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    if (saved === 'dark' || (!saved && prefersDark)) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, []);

  return (
    <BrowserRouter>
      {/* <SystemStatusGuard> */}
        <AuthProvider>
          <AuthModalProvider>
            <FeatureFlagsProvider>
              <AppShell />
            </FeatureFlagsProvider>
          </AuthModalProvider>
        </AuthProvider>
      {/* </SystemStatusGuard> */}
    </BrowserRouter>
  );
}

function AppShell() {
  const location = useLocation();
  const hideDiscountBanner = location.pathname.startsWith('/live-interview-panel')
    || location.pathname.startsWith('/pre-interview-check');

  return (
    <>
      <Toaster position="top-right" richColors={false} theme="light" closeButton expand={false} />
      <AnnouncementSystem />
      {!hideDiscountBanner && <DiscountBanner />}
      <OfflineIndicator />
      <CookieConsentBanner />
      <Routes />
    </>
  );
}

export default App;
